import React, { Component } from 'react'
import fp from 'lodash/fp'
import PropTypes from 'prop-types'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { Link, withRouter } from 'react-router-dom'

import * as ROUTES from 'config/routes'
import ListView from './components/list-view'
import ListViewZones from './components/list-view-zones'
import ListViewAgents from './components/list-view-agents'
import ListViewReaders from './components/list-view-readers'
import ListViewAntennas from './components/list-view-antennas'
import ListViewCameras from './components/list-view-cameras'
import FilterBar from './components/filter-bar'
import { API_PENDING, API_SUCCESS, API_FAIL } from 'redux/api/constants'
import { Col, Row, Spinner, TextInput } from 'elements'
import { clientsSelector, currentClientStatusSelector, allSitesInfoSelector,
         allZonesInfoSelector, agentsSelector, allReadersInfoSelector, 
         allAntennasInfoSelector, camerasSelector } from 'redux/selectors'
import { jsonToQueryString, parseQueryString } from 'utils/helpers'
import { listClients } from 'redux/modules/model/client'
import { listAllSites, listAllZones, listAllReaders, listAllAntennas } from 'redux/modules/model/site';
import { listAllCameras } from 'redux/modules/model/camera';
import { listAllAgents } from 'redux/modules/model/agent';
import { logUserTab } from 'redux/modules/user/index'
import { withClientId } from 'hocs'

const predicate = (criteria) => (item) => {
    if (criteria.search) {
        const ucSearch = criteria.search.toUpperCase()
        return item.clientId.toUpperCase().includes(ucSearch)
    }
    return true
}

class SummaryList extends Component {
    static propTypes = {
        history: PropTypes.object.isRequired,
        listClients: PropTypes.func.isRequired,
        logUserTab: PropTypes.func.isRequired,
        location: PropTypes.object.isRequired,
        clientList: PropTypes.array.isRequired,
        operatorListStatus: PropTypes.string.isRequired
    };

    constructor(props) {
        super(props)
        this.state = {
            search: null
        }
    }

    componentDidMount() {
        const { clientId, listClients, logUserTab, listAllSites, listAllAgents,
                 listAllZones, listAllReaders, listAllAntennas, listAllCameras } = this.props
        listClients({ clientId })
        listAllSites({ clientId })
        listAllAgents({ clientId })
        listAllZones({ clientId })
        listAllReaders({ clientId })
        listAllAntennas({ clientId })
        listAllCameras({ clientId })
        const tab = "Summary"
        logUserTab({ clientId, tab })
    }

    setURLHref = (params) => {
        const { history } = this.props
        history.push({
            location: ROUTES.DIRECTORY,
            search: jsonToQueryString(params)
        })
    };

    handleViewModeChange = (view) => {
        const { location } = this.props
        const params = {
            ...parseQueryString(location.search),
            view
        }
        this.setURLHref(params)
    };

    handleSearchChange = (e) => {
        this.setState({
            search: e.target.value
        })
    }

    render() {
        const { clientList, operatorListStatus, location, sites, zones, 
                agents, readers, antennas, cameras } = this.props
        const params = parseQueryString(location.search)
        const { view = 'list' } = params
        const criteria = {
            ...params,
            search: this.state.search || params.search
        }
        const filteredSites = fp.filter(predicate(criteria))(sites)
        const filteredZones = fp.filter(predicate(criteria))(zones)
        const filteredAgents = fp.filter(predicate(criteria))(agents)
        const filteredReaders = fp.filter(predicate(criteria))(readers)
        const filteredAntennas = fp.filter(predicate(criteria))(antennas)
        const filteredCameras = fp.filter(predicate(criteria))(cameras)

        return (
            <div>
                <FilterBar setURLHref={this.setURLHref} onSearchChange={this.handleSearchChange} />
                {API_PENDING === operatorListStatus && <Spinner />}
                {API_SUCCESS === operatorListStatus && <ListView sites={filteredSites} />}
                {API_SUCCESS === operatorListStatus && <ListViewAgents agents={filteredAgents} />}
                {API_SUCCESS === operatorListStatus && <ListViewZones zones={filteredZones} />}
                {API_SUCCESS === operatorListStatus && <ListViewReaders readers={filteredReaders} />}
                {API_SUCCESS === operatorListStatus && <ListViewAntennas antennas={filteredAntennas} />}
                {API_SUCCESS === operatorListStatus && <ListViewCameras cameras={filteredCameras} />}
                {API_FAIL === operatorListStatus && <h2>Failed to load</h2>}
            </div>
        )
    }
}

export const selector = createStructuredSelector({
    clientList: clientsSelector,
    operatorListStatus: currentClientStatusSelector,
    sites: allSitesInfoSelector,
    zones: allZonesInfoSelector,
    agents: agentsSelector,
    readers: allReadersInfoSelector,
    antennas: allAntennasInfoSelector,
    cameras: camerasSelector
})

export const actions = {
    listClients,
    listAllSites,
    listAllZones,
    listAllAgents,
    listAllReaders,
    listAllAntennas,
    listAllCameras,
    logUserTab
}

export default compose(
    withRouter,
    withClientId,
    connect(selector, actions),
)(SummaryList)



// WEBPACK FOOTER //
// ./src/pages/summary/summary-list/index.js